import React, { FC } from 'react';
import { Tag, MessageMood } from '@trainline/depot-web';

const getStatusMood = (status: string): MessageMood => {
  switch (status) {
    case 'issuing':
      return MessageMood.WARNING;
    case 'issued':
      return MessageMood.POSITIVE;
    case 'superseded':
      return MessageMood.INFO;
    default:
      return MessageMood.NEGATIVE;
  }
};

interface Props {
  status: string;
}

const VendorStatus: FC<Props> = ({ status }) => {
  if (!status) {
    return null;
  }

  return <Tag mood={getStatusMood(status.toLowerCase())} label={status} typeStyle="small" />;
};

export default VendorStatus;
